import { Context } from 'data/context'
import { useContext, useEffect, useState, } from 'react'

export type IAppTheme = 'light' | 'dark'

export const themes = [
    {
        label: 'Light', value: 'light'
    },
    {
        label: 'Dark', value: 'dark'
    }
]

export const useAppTheme = () => {
    const [appTheme, setAppTheme] = useState<IAppTheme>()
    const context = useContext(Context)

    useEffect(() => {
        if (!context.theme) {
            setAppTheme('light')
        }

        else {
            setAppTheme(context.theme)
        }
    }, [context.theme])

    return appTheme;
}